import { Errors } from "../errors"

export default {
  // Generic Errors
  [Errors.GENERIC_ERROR]: "Something went wrong",
  [Errors.INTERNAL_SERVER_ERROR]: "Internal server error",
  [Errors.INVALID_REQUEST_ERROR]: "Invalid request",
  [Errors.TOO_MANY_REQUESTS]: "Too many requests",
  [Errors.INVALID_TYPE]: "Invalid type",
  [Errors.INVALID_JSON]: "Invalid JSON",
  [Errors.INVALID_UUID]: "Invalid UUID",
  [Errors.INVALID_COUNTRY]: "Invalid country – use ISO 3166-1 alpha-2 code",
  [Errors.INVALID_PHONE_NUMBER]: "Invalid phone number",
  [Errors.INVALID_URL]: "Invalid URL",
  [Errors.INVALID_OBJECT]: "Invalid object",
  [Errors.INVALID_DATE]: "Invalid date",
  [Errors.INVALID_NUMBER]: "Invalid number",
  [Errors.TIMEOUT]: "Action timed out",
  [Errors.ID_REQUIRED]: "ID is required",
  [Errors.DATE_RANGE_INVALID]: "Date range is invalid",
  [Errors.DATE_IN_FUTURE]: "Date is in the future",
  [Errors.DATE_RANGE_TOO_LONG]: "Date range is too long",
  [Errors.IDENTIFIER_REQUIRED]: "Identifier required",
  [Errors.IDENTIFIER_ALREADY_EXISTS]: "Identifier already exists",
  [Errors.FIELD_REQUIRED]: "Field is required",
  [Errors.FIELD_MAX_LENGTH]: "Field has too many characters",
  [Errors.CONTENT_EXTRACTION_FAILED]: "Content extraction failed",
  [Errors.MISSING_FILE_FIELD]: "Missing attachment file",
  [Errors.ACTION_NOT_SCOPED]: "This action is not associated with a company",
  // Auth
  [Errors.ADMIN_ALREADY_EXISTS]: "Admin already exists",
  [Errors.ADMIN_NOT_FOUND]: "Admin not found",
  [Errors.EMAIL_NOT_CORPORATE]: "Email needs to be from a company",
  [Errors.EMAIL_INVALID]: "Invalid email",
  [Errors.EMAIL_REQUIRED]: "Email is required",
  [Errors.EMPLOYEE_NOT_FOUND]: "Employee not found",
  [Errors.LOGIN_CREDENTIALS_INVALID]: "Invalid email or password",
  [Errors.NAME_REQUIRED]: "Name is required",
  [Errors.PASSWORD_INVALID]: "Invalid password",
  [Errors.PASSWORD_MIN_LENGTH]: "Password needs to have at least 5 characters",
  [Errors.WEAK_PASSWORD_USED]: "Password is weak. Cannot use this password in production.",
  [Errors.PASSWORD_REQUIRED]: "Password is required",
  [Errors.OLD_PASSWORD_INVALID]: "Old password invalid",
  [Errors.PASSWORD_DONT_MATCH]: "Passwords don't match",
  [Errors.TOKEN_NOT_FOUND]: "Token not found",
  [Errors.API_TOKEN_READ_ONLY]: "This API token is read-only",
  [Errors.UNAUTHORIZED]: "Unauthorized",
  [Errors.ROLE_IS_REQUIRED]: "A role is required",
  [Errors.WEBSITE_NOT_REACHABLE]:
    "We couldn't reach your company website. Please check the email domain and try again.",
  [Errors.SETUP_TOKEN_NOT_FOUND]: "Setup session expired or not found. Please start over.",
  // Employees
  [Errors.AVATAR_FILE_SIZE_EXCEEDED]: "Avatar file size exceeded",
  [Errors.EMPLOYEE_ALREADY_EXISTS]: "Employee already exists",
  [Errors.EMPLOYEE_EMAIL_INVALID]: "Invalid employee email",
  [Errors.EMPLOYEE_EMAIL_REQUIRED]: "Employee email is required",
  [Errors.EMPLOYEE_NAME_REQUIRED]: "Employee name is required",
  [Errors.EMPLOYEE_LOCALE_REQUIRED]: "Employee language is required",
  [Errors.EMPLOYEE_PERMISSIONS_REQUIRED]: "Employee permissions are required",
  [Errors.EMPLOYEE_ALREADY_ARCHIVED]: "Employee is already archived",
  [Errors.EMPLOYEE_NOT_ARCHIVED]: "Employee is not archived",
  [Errors.CANNOT_ARCHIVE_YOURSELF]: "You cannot archive yourself",
  [Errors.EMPLOYEE_ALREADY_OWNER]: "This employee is already the owner",
  [Errors.INVITATION_ALREADY_SENT]: "Invitation already sent",
  [Errors.INVITATION_NOT_FOUND]: "Invitation not found",
  [Errors.INVITATION_TOKEN_NOT_FOUND]: "Invitation token not found",
  [Errors.LOCALE_REQUIRED]: "Language is required",
  // Organizations
  [Errors.ORGANIZATION_NOT_FOUND]: "Organization not found",
  [Errors.ORGANIZATION_SLUG_ALREADY_EXISTS]: "Organization slug already exists",
  [Errors.ORGANIZATION_TYPE_INVALID]: "Organization type is invalid",
  // Companies
  [Errors.COMPANY_NOT_FOUND]: "Company not found",
  [Errors.VAULT_ENTRY_NOT_FOUND]: "Vault entry not found",
  [Errors.VAULT_KEY_INVALID]:
    "Use only letters, numbers and underscores, and do not start with a number. For example: MY_API_KEY",
  [Errors.VAULT_SECRET_NOT_ALLOWED]: "Secret values cannot be used here",
  [Errors.REFERRAL_LEAD_NOT_FOUND]: "Referral lead not found",
  [Errors.COMPANY_ID_REQUIRED]: "Company ID is required",
  [Errors.ORGANIZATION_ID_REQUIRED]: "Organization ID is required",
  [Errors.COMPANY_ALREADY_EXISTS]: "Company already exists",
  [Errors.COMPANY_NAME_IS_REQUIRED]: "Company name is required",
  [Errors.COMPANY_WITHOUT_OWNER]: "Company does not have an owner",
  [Errors.COMPANY_SLUG_ALREADY_EXISTS]: "Company slug already exists",
  [Errors.COMPANY_SIZE_REQUIRED]: "Company size is required",
  [Errors.COMPOSER_CUSTOM_PROMPT_INVALID]: "This content conflicts with agent rules",
  // Billing
  [Errors.ORGANIZATION_SUBSCRIPTION_NOT_FOUND]: "Subscription not found",
  [Errors.CREDITS_PACKAGE_NOT_FOUND]: "Credits package not found",
  [Errors.NO_PACKAGE_CREDITS_AVAILABLE]: "No package credits available",
  [Errors.STRIPE_CUSTOMER_ID_REQUIRED]: "Stripe customer ID is required",
  [Errors.STRIPE_PRICE_NOT_FOUND]: "Stripe price not found",
  [Errors.CREDIT_TRANSACTION_NOT_FOUND]: "Credit transaction not found",
  // Customers
  [Errors.CUSTOMER_NOT_FOUND]: "Customer not found",
  [Errors.CUSTOMER_METADATA_INVALID]: "Invalid metadata",
  [Errors.CUSTOMER_NAME_INVALID]: "Invalid name",
  [Errors.CUSTOMER_PHONE_INVALID]: "Invalid phone",
  [Errors.CUSTOMER_USES_CHANNEL]: "Customer uses a real channel, so messages cannot be sent",
  [Errors.CUSTOMER_EMAIL_NOR_PHONE_FOUND]: "Customer email or phone not found",
  [Errors.CUSTOMER_NOT_IN_MANUAL_CONTROL]: "Customer is not in manual control",
  [Errors.CUSTOMER_PHONE_NUMBER_REQUIRED]: "Customer phone number is required",
  [Errors.CUSTOMER_WITH_PHONE_ALREADY_EXISTS]: "A customer with this phone already exists",
  [Errors.CUSTOMER_WITHOUT_EMAIL_OR_TENTATIVE_EMAIL]:
    "Customer does not have an email or tentative email",
  // Company Clients
  [Errors.COMPANY_CLIENT_NOT_FOUND]: "Company client not found",
  // Campaigns
  [Errors.CAMPAIGN_INVALID]: "Campaign is invalid",
  [Errors.CAMPAIGN_ID_REQUIRED]: "Campaign ID is required",
  [Errors.CAMPAIGN_NOT_FOUND]: "Campaign not found",
  [Errors.CAMPAIGN_NOT_LAUNCHED]: "The campaign is not launched",
  [Errors.CAMPAIGN_NOT_ACTIVE]: "Campaign is not active",
  [Errors.CAMPAIGN_STATUS_INVALID]: "The campaign status is invalid",
  [Errors.CAMPAIGN_GOAL_INVALID]: "Invalid goal",
  [Errors.CAMPAIGN_GOALS_REQUIRED]:
    "At least one non-underlying goal is required for outbound campaigns",
  [Errors.CAMPAIGN_GOAL_NOT_FOUND]: "Campaign goal not found",
  [Errors.CAMPAIGN_TEMPLATES_REQUIRED]: "At least one template is required",
  [Errors.CAMPAIGN_OPENING_MESSAGES_REQUIRED]: "At least one opening message is required",
  [Errors.CAMPAIGN_TEMPLATE_NOT_FOUND]: "Template not found",
  [Errors.CAMPAIGN_TRIGGER_INVALID]: "Invalid trigger",
  [Errors.CAMPAIGN_TRIGGER_NOT_FOUND]: "Campaign trigger not found",
  [Errors.CAMPAIGN_SCHEDULE_IN_PAST]: "The launch time must be in the future",
  [Errors.CAMPAIGN_LAUNCH_NOT_FOUND]: "Campaign launch not found",
  [Errors.CAMPAIGN_LAUNCH_NOT_SCHEDULED]: "This launch has already started or was cancelled",
  [Errors.CAMPAIGN_CONDITION_INVALID]: "Invalid condition",
  [Errors.CAMPAIGN_ACTION_INVALID]: "Invalid campaign actions",
  [Errors.CAMPAIGN_EVENT_INVALID]: "Invalid campaign events",
  [Errors.CAMPAIGN_EVENT_WITHOUT_ACTION]: "Each event must have at least one action",
  [Errors.WORKFLOW_IMPORT_INVALID_FILE]:
    "This file was modified or isn't a valid Permut workflow file",
  [Errors.CAMPAIGN_CHANNEL_REQUIRED]: "At least one channel is required",
  [Errors.CAMPAIGN_DEFAULT_LANGUAGE_REQUIRED]: "Default language is required",
  [Errors.CAMPAIGN_DEFAULT_LANGUAGE_TEMPLATE_REQUIRED]:
    "Add an active template for the default language",
  [Errors.CAMPAIGN_ALREADY_ARCHIVED]: "Campaign is already archived",
  [Errors.CAMPAIGN_NOT_ARCHIVED]: "Campaign is not archived",
  [Errors.CAMPAIGN_NODE_NOT_FOUND]: "Campaign node not found",
  [Errors.CAMPAIGN_NODE_TYPE_NOT_FOUND]: "Campaign node type not found",
  [Errors.CAMPAIGN_TRIGGER_QR_WITHOUT_QR]: "Campaign requires a QR",
  [Errors.CAMPAIGN_TRIGGER_INSTAGRAM_WITHOUT_ACCOUNT]: "Campaign requires an Instagram account",
  [Errors.CAMPAIGN_TRIGGER_MESSENGER_WITHOUT_PAGE]: "Campaign requires a Facebook page",
  [Errors.CAMPAIGN_CHANNEL_GMAIL_WITHOUT_ACCOUNT]: "Campaign requires a Gmail account",
  [Errors.CAMPAIGN_CHANNEL_OUTLOOK_WITHOUT_ACCOUNT]: "Campaign requires an Outlook account",
  [Errors.CAMPAIGN_TRIGGER_INSTAGRAM_INVALID_AUDIENCE]: "Instagram campaign audience invalid",
  [Errors.CAMPAIGN_TRIGGER_INSTAGRAM_INVALID_REPLY]:
    "At least a comment reply is required on Instagram",
  [Errors.CAMPAIGN_NUMBER_OR_INTEGRATION_ID_REQUIRED]:
    "Campaign requires a Whatsapp number or mail integration",
  [Errors.CAMPAIGN_WHATSAPP_DEFAULT_IMMUTABLE]:
    "The WhatsApp Default campaign trigger and channel cannot be changed",
  [Errors.CAMPAIGN_CALLBACK_URL_REQUIRED]: "Callback URL is required for API channel campaigns",
  [Errors.CAMPAIGN_CALLBACK_URL_INVALID]: "Enter a valid http or https callback URL",
  [Errors.CAMPAIGN_CALLBACK_URL_MISSING_REFERENCE_ID_MACRO]:
    "The URL must include referenceId in the path or as a query parameter named referenceId",
  [Errors.CAMPAIGN_FLOW_REQUIRED]: "Campaign flow is required",
  // Clusters
  [Errors.CLUSTER_SNAPSHOT_NOT_FOUND]: "Cluster snapshot not found",
  [Errors.CANONICAL_TOPIC_NOT_FOUND]: "Canonical topic not found",
  // Conversations
  [Errors.CONVERSATION_NOT_FOUND]: "Conversation not found",
  [Errors.CONVERSATION_ALREADY_ACTIVE]: "The conversation is already active",
  [Errors.CONVERSATION_IS_NOT_TESTING]: "The conversation is not testing",
  [Errors.CONVERSATION_IS_NOT_CAMPAIGN]: "The conversation is not a campaign",
  [Errors.CONVERSATION_ALREADY_HAS_MESSAGES]: "The conversation already has messages",
  [Errors.CONVERSATION_NOT_STARTED]: "The conversation has not started",
  [Errors.CONVERSATION_RESPONSE_NOT_FOUND]: "Conversation response not found",
  [Errors.CONVERSATION_OPPORTUNITY_NOT_FOUND]: "Conversation opportunity not found",
  [Errors.CONVERSATION_ORDER_ACTION_NOT_FOUND]: "Conversation order action not found",
  [Errors.SHORT_LINK_NOT_FOUND]: "Short link not found",
  // Goals
  [Errors.GOAL_NOT_FOUND]: "Goal not found",
  [Errors.GOAL_ASSISTANT_INSTRUCTIONS_REQUIRED]:
    "Assistant instructions are required for this goal type",
  [Errors.GOAL_OPTIONS_REQUIRED]: "Goal options are required",
  [Errors.GOAL_OPTIONS_MIN_REQUIRED]: "At least 2 options are required",
  [Errors.GOAL_OPTIONS_MAX_REQUIRED]: "Maximum 10 options are allowed",
  [Errors.GOAL_OPTIONS_NPS_REQUIRED]: "NPS options are required for goal",
  [Errors.CONVERSATION_GOAL_NOT_FOUND]: "Conversation goal not found",
  [Errors.GOAL_MEDIA_UPLOAD_ERROR]: "Error while uploading media for the goal",
  [Errors.GOAL_NAME_ALREADY_EXISTS]: "A goal with this name already exists",
  // Klaviyo
  [Errors.KLAVIYO_INTEGRATION_NOT_FOUND]: "Klaviyo integration not found",
  // Messages
  [Errors.MESSAGE_NOT_FOUND]: "Message not found",
  [Errors.MESSAGE_IDENTIFIER_NOT_FOUND]: "Message identifier not found",
  // Meta
  [Errors.WHATSAPP_TEMPLATE_NOT_FOUND]: "Whatsapp template not found",
  [Errors.WHATSAPP_TEMPLATE_ALREADY_EXISTS]: "Whatsapp template already exists",
  [Errors.WHATSAPP_TEMPLATE_ALREADY_PENDING]: "Whatsapp template already pending",
  [Errors.WHATSAPP_TEMPLATE_INVALID_TEMPLATE]: "Invalid template",
  [Errors.WHATSAPP_TEMPLATE_VARIABLE_AT_EDGE]:
    "Variables can't be at the start or end of the template. Add fixed text around them.",
  [Errors.WHATSAPP_TEMPLATE_INVALID_VARIABLES]: "Invalid template variables",
  [Errors.WHATSAPP_TEMPLATE_VARIABLE_NAME_INVALID]:
    "Invalid template variable name, it can only contain lowercase letters and underscores",
  [Errors.WHATSAPP_TEMPLATE_VARIABLE_EXAMPLE_REQUIRED]: "Example is required",
  [Errors.WHATSAPP_INTEGRATION_NOT_FOUND]: "Whatsapp integration not found",
  [Errors.WHATSAPP_NUMBER_NOT_FOUND]: "Whatsapp number not found",
  [Errors.WHATSAPP_OPENING_MESSAGE_NOT_FOUND]: "Whatsapp opening message not found",
  [Errors.WHATSAPP_EXCHANGE_TOKEN_ERROR]: "Error while generating the exchange token",
  [Errors.WHATSAPP_SUBSCRIBED_APP_ERROR]: "Error while subscribing to Permut's app",
  [Errors.WHATSAPP_DOWNLOAD_MEDIA_FAILED]: "Error while downloading media file",
  [Errors.WHATSAPP_PREPARE_MEDIA_FAILED]: "Error while preparing media file",
  [Errors.WHATSAPP_UPLOAD_MEDIA_FAILED]: "Error while uploading media file",
  [Errors.WHATSAPP_MESSAGE_HANDLER_FAILED]: "Error handling Whatsapp message",
  [Errors.WHATSAPP_TEMPLATE_EDIT_24H]: "Whatsapp templates can be edited once in 24h",
  [Errors.WHATSAPP_ERROR_UPDATING_TEMPLATE]: "Error while updating Whatsapp template",
  [Errors.WHATSAPP_ERROR_VERIFYING_NUMBER]: "Error while verifying phone number",
  // SalesForce
  [Errors.SALES_FORCE_INTEGRATION_NOT_FOUND]: "SalesForce integration not found",
  [Errors.SALES_FORCE_KEYMAP_NOT_FOUND]: "SalesForce key-map relation not found",
  // S3
  [Errors.S3_DOWNLOAD_ERROR]: "S3 download error",
  [Errors.S3_NOT_CONFIGURED]: "S3 not configured",
  [Errors.S3_UPLOAD_ERROR]: "S3 upload error",
  [Errors.S3_UPLOAD_FILE_TYPE_INVALID]: "Invalid file type",
  // Dashboard
  [Errors.ERROR_PROCESSING_CLUSTERS]: "Error while processing the clusters",
  // Knowledge Base
  [Errors.KNOWLEDGE_BASE_ITEM_NOT_FOUND]: "Knowledge base item not found",
  [Errors.KNOWLEDGE_BASE_ITEM_CONTENT_INVALID]: "Invalid content",
  [Errors.KNOWLEDGE_BASE_UNSUPPORTED_FILE_FORMAT]:
    "Unsupported file format. Only PDF, PNG, JPEG, WebP, and GIF files are allowed.",
  [Errors.KNOWLEDGE_BASE_FILE_SIZE_EXCEEDED]: "File size exceeds the maximum allowed size of 20 MB",
  [Errors.WEBPAGE_NOT_FOUND]: "Webpage not found",
  [Errors.KNOWLEDGE_BASE_ITEM_ALREADY_EXISTS]: "Knowledge base item already exists",
  // Conversation Tickets & Questions
  [Errors.CONVERSATION_TICKET_NOT_FOUND]: "Conversation ticket not found",
  [Errors.ISSUE_NOT_FOUND]: "Ticket not found",
  [Errors.CONVERSATION_QUESTION_NOT_FOUND]: "Conversation question not found",
  [Errors.LOGISTICS_TICKET_INTEGRATION_NOT_FOUND]: "Logistics ticket integration not found",
  // Shopify Integration
  [Errors.SHOPIFY_INTEGRATION_NOT_FOUND]: "Shopify integration not found",
  [Errors.SHOPIFY_INTEGRATION_INVALID]: "Shopify integration is invalid",
  [Errors.SHOPIFY_ORDER_NOT_FOUND]: "Shopify order not found",
  [Errors.SHOPIFY_ORDER_MISMATCH_EMAIL]: "Shopify order email does not match customer email",
  [Errors.SHOPIFY_ORDER_MISMATCH_CONTACT]:
    "Shopify order contact does not match the provided contact",
  [Errors.SHOPIFY_ORDER_MISMATCH_ID]: "Shopify order ID does not match the provided order ID",
  [Errors.SHOPIFY_CUSTOMER_ORDERs_NOT_FOUND]: "Shopify customer's orders not found",
  [Errors.SHOPIFY_CUSTOMER_NOT_FOUND]: "Shopify customer not found",
  [Errors.SHOPIFY_REFUND_ORDER_NOT_FOUND]: "Shopify refund order not found",
  [Errors.SHOPIFY_REQUEST_ERROR]: "Error while requesting Shopify",
  [Errors.SHOPIFY_REQUEST_PARSE_INVALID]: "Shopify response schema is invalid",
  [Errors.SHOPIFY_CATALOG_SEARCH_ERROR]: "Error searching Shopify catalog",
  [Errors.SHOPIFY_PRODUCT_FETCH_ERROR]: "Error fetching Shopify products",
  [Errors.SHOPIFY_UNAUTHORIZED]:
    "Shopify authorization expired. Please reconnect the Shopify integration",
  [Errors.SHOPIFY_LOCATIONS_ACCESS_DENIED]:
    "Shopify denied access to locations. Please grant permissions to the Shopify app",
  [Errors.SHOPIFY_SIZE_CHARTS_DISABLED]:
    "Size chart conversion is disabled for this Shopify integration. Enable it in integration settings",
  // Importers
  [Errors.EXCEL_WORKBOOK_EMPTY]: "Excel workbook is empty",
  [Errors.EXCEL_WORKBOOK_INVALID_DATA]: "Excel workbook contains invalid data",
  [Errors.EXCEL_WORKBOOK_INVALID_FORMAT]:
    "The uploaded file is not a valid Excel file. Please upload a .xlsx file.",
  [Errors.CUSTOMER_IMPORT_NOT_FOUND]: "Customer import not found",
  [Errors.CUSTOMER_IMPORT_TOO_LARGE]:
    "This import is too large. Please split the file into smaller batches.",
  // QRs
  [Errors.QR_NOT_FOUND]: "QR not found",
  [Errors.QR_WITHOUT_CAMPAIGN]: "QR without campaign",
  // Opening messages
  [Errors.OPENING_MESSAGE_TEXT_NO_IDENTIFIER_VARIABLE]:
    "The message must include the variable {{identifier}}",
  // Segments
  [Errors.SEGMENT_ALREADY_EXISTS]: "Segment already exists",
  [Errors.SEGMENT_NOT_FOUND]: "Segment not found",
  [Errors.SEGMENT_CUSTOMER_NOT_FOUND]: "Customer not found in segment",
  [Errors.SEGMENT_GROUP_NOT_FOUND]: "Segment group not found",
  [Errors.SEGMENT_GROUP_ALREADY_EXISTS]: "Segment group already exists",
  [Errors.ONE_SEGMENT_RULE_REQUIRED]: "At least one segment rule is required",
  // BigBlue
  [Errors.BIGBLUE_REQUEST_ERROR]: "Error while requesting BigBlue",
  [Errors.BIGBLUE_INTEGRATION_NOT_FOUND]: "BigBlue integration not found",
  [Errors.BIGBLUE_ORDER_NOT_FOUND]: "BigBlue order not found",
  [Errors.BIGBLUE_ORDER_MISMATCH_EMAIL]: "BigBlue order email does not match customer email",
  [Errors.BIGBLUE_ORDER_MISMATCH_ID]: "BigBlue order ID does not match the provided order ID",
  // Reveni
  [Errors.REVENI_INTEGRATION_NOT_FOUND]: "Reveni integration not found",
  [Errors.REVENI_RETURN_NOT_FOUND]: "Reveni return not found",
  [Errors.REVENI_RETURN_MISMATCH_EMAIL]: "Reveni return email does not match customer email",
  [Errors.REVENI_RETURN_MISMATCH_ID]: "Reveni return order ID does not match the provided order ID",
  [Errors.REVENI_REQUEST_ERROR]: "Error while requesting Reveni",
  // LoopReturns
  [Errors.LOOP_RETURNS_INTEGRATION_NOT_FOUND]: "Loop Returns integration not found",
  [Errors.LOOP_RETURNS_RETURN_NOT_FOUND]: "Loop Returns return not found",
  [Errors.LOOP_RETURNS_RETURN_MISMATCH_EMAIL]:
    "Loop Returns return email does not match customer email",
  [Errors.LOOP_RETURNS_RETURN_MISMATCH_ID]:
    "Loop Returns return order ID does not match the provided order ID",
  [Errors.LOOP_RETURNS_REQUEST_ERROR]: "Error while requesting Loop Returns",
  // Rever
  [Errors.REVER_INTEGRATION_NOT_FOUND]: "Rever integration not found",
  [Errors.REVER_RETURN_NOT_FOUND]: "Rever return not found",
  [Errors.REVER_RETURN_MISMATCH_EMAIL]: "Rever return email does not match customer email",
  [Errors.REVER_RETURN_MISMATCH_ID]: "Rever return order ID does not match the provided order ID",
  [Errors.REVER_REQUEST_ERROR]: "Error while requesting Rever",
  // Zendesk
  [Errors.ZENDESK_INTEGRATION_NOT_FOUND]: "Zendesk integration not found",
  [Errors.ZENDESK_INVALID_CREDENTIALS]:
    "Zendesk credentials are invalid. Please, check them and try again.",
  [Errors.ZENDESK_TOKEN_REQUIRED]: "Token is required",
  [Errors.ZENDESK_COMPANY_SUBDOMAIN_REQUIRED]: "Company subdomain is required",
  [Errors.ZENDESK_SUBJECT_TITLE_REQUIRED]: "Ticket title is required",
  // Gorgias
  [Errors.GORGIAS_INTEGRATION_NOT_FOUND]: "Gorgias integration not found",
  [Errors.GORGIAS_INVALID_CREDENTIALS]:
    "Gorgias credentials are invalid. Please, check them and try again.",
  [Errors.GORGIAS_SUBJECT_REQUIRED]: "Subject is required",
  [Errors.GORGIAS_BODY_REQUIRED]: "Body is required",
  [Errors.GORGIAS_BASE_API_URL_REQUIRED]: "Base API URL is required",
  [Errors.GORGIAS_TOKEN_REQUIRED]: "Token is required",
  [Errors.GORGIAS_USERNAME_REQUIRED]: "Username is required",
  // FrontApp
  [Errors.FRONTAPP_INTEGRATION_NOT_FOUND]: "FrontApp integration not found",
  [Errors.FRONTAPP_INVALID_CREDENTIALS]:
    "FrontApp credentials are invalid. Please, check them and try again.",
  [Errors.FRONTAPP_SUBJECT_REQUIRED]: "Subject is required",
  [Errors.FRONTAPP_BODY_REQUIRED]: "Body is required",
  [Errors.FRONTAPP_TOKEN_REQUIRED]: "Token is required",
  // Widget
  [Errors.WIDGET_CONVERSATION_SLUG_NOT_FOUND]: "Conversation not found",
  [Errors.WIDGET_BUBBLE_IMAGE_FILE_NOT_FOUND]: "Image for widget bubble not found",
  [Errors.WIDGET_IFRAME_BACKGROUND_IMAGE_FILE_NOT_FOUND]:
    "Image for widget iframe background not found",
  // Company integration configuration
  [Errors.COMPANY_INTEGRATION_CONFIGURATION_NOT_FOUND]:
    "Company integration configuration not found",
  [Errors.COMPANY_INTEGRATION_CONFIGURATION_FIND_ORDER_DISABLED]:
    "Find order not enabled on company integration configuration",
  [Errors.COMPANY_INTEGRATION_CONFIGURATION_CHECK_RETURN_DISABLED]:
    "Check return not enabled on company integration configuration",
  [Errors.COMPANY_INTEGRATION_CONFIGURATION_CANCEL_ORDER_DISABLED]:
    "Cancel order not enabled on company integration configuration",
  // Cancelled orders
  [Errors.CANCELLATION_REASON_REQUIRED]: "Cancellation reason required",
  // Insights
  [Errors.INSIGHT_SIGNAL_NOT_FOUND]: "Signal not found",
  [Errors.INSIGHT_SIGNAL_EMPLOYEE_SOLUTION_NOT_FOUND]: "Signal employee solution not found",
  // Instagram
  [Errors.INSTAGRAM_INTEGRATION_NOT_FOUND]: "Instagram integration not found",
  [Errors.INSTAGRAM_PROFILE_NOT_FOUND]: "Instagram profile not found",
  [Errors.INSTAGRAM_ACCESS_TOKEN_ERROR]: "Error generating Instagram access token",
  [Errors.INSTAGRAM_LONG_LIVED_ACCESS_TOKEN_ERROR]:
    "Error generating long lived Instagram access token",
  [Errors.INSTAGRAM_REFRESH_TOKEN_ERROR]: "Error refreshing Instagram access token",
  [Errors.INSTAGRAM_CAMPAIGN_NOT_FOUND]: "No relation found between instagram account and campaign",
  [Errors.INSTAGRAM_MEDIA_NOT_FOUND]: "Instagram media not found",
  [Errors.INSTAGRAM_ERROR_REPLY_COMMENT]: "Error while responding Instagram comment",
  [Errors.INSTAGRAM_SUBSCRIBE_APP_ERROR]: "Error while subscribing to Instagram app",
  [Errors.INSTAGRAM_NO_ACCOUNTS]: "No Instagram account was shared during the connection",
  // Messenger
  [Errors.MESSENGER_INTEGRATION_NOT_FOUND]: "Messenger integration not found",
  [Errors.MESSENGER_NO_PAGES]: "No Facebook page was shared during the connection",
  [Errors.MESSENGER_SUBSCRIBE_APP_ERROR]: "Error while subscribing the Facebook page",
  [Errors.MESSENGER_ERROR_REPLY_COMMENT]: "Error while responding Facebook comment",
  // Meta
  [Errors.META_EXCHANGE_TOKEN_ERROR]: "Error generating Meta access token",
  // Change Log
  [Errors.CHANGE_LOG_NOT_FOUND]: "Change log not found",
  // Capabilities
  [Errors.CAPABILITY_NOT_FOUND]: "Capability not found",
  [Errors.MCP_CONNECTION_FAILED]: "Failed to connect to MCP server",
  [Errors.MCP_EXECUTION_TIMEOUT]: "MCP tool execution timed out",
  [Errors.MCP_TOOL_EXECUTION_FAILED]: "MCP tool execution failed",
  [Errors.MCP_TOOL_NOT_FOUND]: "MCP tool not found",
  [Errors.MCP_INVALID_AUTH]: "Invalid MCP authentication credentials",
  [Errors.CAPABILITY_CONFIG_INVALID]: "Capability configuration is invalid",
  [Errors.CAPABILITY_NOT_AVAILABLE]:
    "Capability is not available because the required integration is missing",
  [Errors.CAPABILITY_ALREADY_INSTALLED]: "Capability already installed",
  [Errors.CAPABILITY_CANNOT_BE_ENABLED]: "Capability cannot be enabled",
  [Errors.CAPABILITY_EXECUTION_NOT_FOUND]: "Capability execution not found",
  // Amphora
  [Errors.AMPHORA_INTEGRATION_NOT_FOUND]: "Amphora integration not found",
  [Errors.AMPHORA_INTEGRATION_INVALID]: "Amphora integration invalid",
  [Errors.AMPHORA_ORDER_NOT_FOUND]: "Amphora order not found",
  [Errors.AMPHORA_ORDER_NO_EMAIL]:
    "It is not possible to check the order status because the order has no email. The ticket will be escalated.",
  [Errors.AMPHORA_ORDER_MISMATCH_EMAIL]: "Amphora order email does not match customer email",
  [Errors.AMPHORA_ORDER_MISMATCH_ID]: "Amphora order ID does not match the provided order ID",
  [Errors.AMPHORA_REQUEST_ERROR]: "Error while making a request to Amphora",
  [Errors.AMPHORA_REQUEST_PARSE_INVALID]: "Error while parsing Amphora response",
  [Errors.AMPHORA_TICKET_NOT_FOUND]: "Amphora ticket not found",
  [Errors.AMPHORA_CUSTOMER_CANNOT_BE_CONTACTED]: "Customer cannot be contacted",
  [Errors.AMPHORA_OWN_WHATSAPP_REQUIRED]:
    "To enable WhatsApp in Amphora communications, your organization must have its own WhatsApp Business account integrated.",
  [Errors.AMPHORA_LOGISTICS_LANGUAGES_REQUIRED]:
    "Select at least one template language for Amphora WhatsApp logistics communications.",
  [Errors.AMPHORA_LOGISTICS_WHATSAPP_NUMBER_REQUIRED]:
    "Add a connected WhatsApp phone number for this company before enabling Amphora WhatsApp logistics communications.",
  // Backoffice
  [Errors.BACKOFFICE_SCHEDULED_REPORT_NOT_FOUND]: "Scheduled report not found",
  [Errors.BACKOFFICE_SCHEDULED_REPORT_ALIAS_ALREADY_EXISTS]:
    "Scheduled report alias already exists",
  // Google sheets
  [Errors.GOOGLE_SHEETS_MISSING_PERMISSIONS]: "Missing permissions for Google sheet",
  [Errors.GOOGLE_SHEETS_ERROR_WRITING]: "Error while writing on Google sheet",
  [Errors.GOOGLE_SHEETS_RANGE_NOT_FOUND]: "Google sheets range not found",
  // Notes
  [Errors.NOTE_NOT_FOUND]: "Note not found",
  [Errors.NOTE_MENTION_NOT_FOUND]: "Note mention not found",
  // Gmail integration
  [Errors.GMAIL_INTEGRATION_NOT_FOUND]: "Gmail integration not found",
  [Errors.GMAIL_INTEGRATION_ERROR_GENERATING_TOKENS]: "Error while generating Gmail tokens",
  [Errors.GMAIL_INTEGRATION_MISSING_SCOPES]: "Missing required Gmail permissions",
  [Errors.GMAIL_USERINFO_NO_EMAIL]: "No email found on Gmail userinfo",
  [Errors.GMAIL_TOKEN_REFRESH_FAILED]:
    "Failed to refresh Gmail access token. Please reconnect Gmail.",
  [Errors.GMAIL_CAMPAIGN_RELATION_NOT_FOUND]: "Gmail integration to campaign relation not found",
  // Outlook integration
  [Errors.OUTLOOK_INTEGRATION_NOT_FOUND]: "Outlook integration not found",
  [Errors.OUTLOOK_INTEGRATION_ERROR_GENERATING_TOKENS]: "Error while generating Outlook tokens",
  [Errors.OUTLOOK_INTEGRATION_MISSING_SCOPES]: "Missing required Outlook permissions",
  [Errors.OUTLOOK_USERINFO_NO_EMAIL]: "No email found on Outlook profile",
  [Errors.OUTLOOK_TOKEN_REFRESH_FAILED]: "Failed to refresh Outlook access token",
  [Errors.OUTLOOK_GRAPH_REQUEST_FAILED]: "Failed the Graph request to Outlook",
}
